import api from "api";
import { takeLatest } from "redux-saga/effects";

import { permissions } from "../actions";
import { FETCH_PERMISSIONS_START } from "../constants";
import { fetchPagedSagaFactory } from "./utils";

export const permissionsSaga = fetchPagedSagaFactory(
  api.Permissions.get,
  permissions.success,
  permissions.failed
);

export function* watchPermissions() {
  yield takeLatest(FETCH_PERMISSIONS_START, permissionsSaga);
}
